import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { fetchLocationsByType } from "../action"; // Modify this action as needed
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
// const renderOptionsForType = (type) => {
//     // Use useSelector to get data based on type
//     const locationData = useSelector(state => state?.profileReducer?.locationData[type]);
//     if (locationData) {
//       return locationData.map(location => (
//         <MenuItem key={location.id} value={location.id}>
//           {location.name}
//         </MenuItem>
//       ));
//     }
//     return null;
//   };
const LocationPicker = ({ label, types, labels, ...props }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
      // Fetch initial data for the first dropdown when component mounts
      fetchLocations(types[0]);
    }, []);
  
    const fetchLocations = async (type, parentId = "") => {
      setLoading(true);
      try {
        const { data } = await dispatch(fetchLocationsByType(type, parentId));
        const locationData = data.locationsStrNotAuth || data.data.locationsStr;
        setOptions(locationData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    const handleChange = (value, index) => {
      if (index < types.length - 1) {
        // Fetch data for the next dropdown based on the selected value
        fetchLocations(types[index + 1], value);
      }
      // Call onChange callback if provided
      if (props.onChange) {
        props.onChange(value);
      }
    };
  
    return (
      <div>
        <label>{label}</label>
        <select
          value={props.value} // Assuming value is passed as a prop
          onChange={(e) => handleChange(e.target.value, types.indexOf(props.type))}
          disabled={loading}
        >
          <option value="">{t("Select")}</option>
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    );
  };
  
export default LocationPicker;
